import "../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { isBrowser as i } from "./utils.js";
import { onMounted as d, onBeforeUnmount as r } from "../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
let o, n;
const f = () => {
  var t, e;
  o = i ? (e = (t = document) === null || t === void 0 ? void 0 : t.fonts) === null || e === void 0 ? void 0 : e.ready : void 0, n = !1, o !== void 0 ? o.then(() => {
    n = !0;
  }) : n = !0;
};
f();
function s(t) {
  if (n)
    return;
  let e = !1;
  d(() => {
    n || o == null || o.then(() => {
      e || t();
    });
  }), r(() => {
    e = !0;
  });
}
export {
  s as default,
  f as init
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vooks@0.2.12_vue@3.5.18/~/vooks/es/on-fonts-ready.js
// module id = 985
// module chunks = 67